import React, { useState, useEffect } from "react";
import ResultForm from "../Components/ResultForm.jsx";
import ResultFormMobile from "../Components/ResultFormMobile.jsx";
import Button from "../Components/Button.jsx";
import copy from "../img/copy.png";
import search from "../img/search.png";
import AskForm from "../Components/AskForm.jsx";
import ComparisonForm from "../Components/ComparisonForm.jsx";
import CaseComparison from "../Components/CaseComparison.jsx";
import CaseSummary from "../Components/CaseSummary.jsx";
import ModalPayCheck from "../Components/Modal/ModalPayCheck.jsx";
import ModalThankLowGrant from "../Components/Modal/ModalThankLowGrant.jsx";
import styled from "styled-components";
import compare_button from "../img/compare_button.png";
// import Loading from "../Components/Loading.jsx";
import PayList from "../Components/PayList.jsx";
import dummyData from "../data/dummyData.json"; // 더미 데이터를 임포트
import ai from "../img/ai.png";
import dots_png from "../img/dots_png.png";
import HeightInterval from "../Components/HeightInterval.jsx";
import { Desktop, Mobile } from "../MediaQuery/OnboardingPageMediaQuery.js";
import RelevanceChart from "../Components/ApexChart/RelevanceChart.jsx";
import Alert from "../Components/Alert.jsx";
import dots_gif from "../img/dots_gif.gif";
import DataLoader from "../Components/ProgressBar/DataLoader.jsx";
import TooltipComponent from "../Components/Tooltip.jsx";
import ModalLawCharge from "../Components/Modal/ModalLawCharge.jsx";
import ReAskForm from "../Components/ReAskForm.jsx";
import SituationBox from "../Components/SituationBox.jsx";
import ModalAskError from "../Components/Modal/ModalAskError.jsx";
import ModalIOSAddToHomeScreen from "../Components/Modal/ModalIOSAddToHomeScreen.jsx";
import ModalSuccessLawCharge from "../Components/Modal/ModalSuccessLawCharge.jsx";
import CaseFeedback from "../Components/CaseFeedback.jsx";
import ModalUserFeedback from "../Components/Modal/ModalUserFeedback.jsx";
import SpinnerSSE from "../Components/SpinnerSSE.jsx";
import ModalUserWithdrawal from "../Components/Modal/ModalUserWithdrawal.jsx";
import ModalMyPage from "../Components/Modal/ModalMyPage.jsx";
import warning from "../img/user_feedback_warning.png";
import SSEProgressStack from "../Components/SSEProgressStack.jsx";
import useStore from "../store.js";
import ChatSearchHistory from "../Components/ChatSearchHistory.jsx";

// 컴포넌트 디자인 확인용 페이지
const Test = () => {
  const [showCompare, setShowCompare] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false); // CaseComparison의 props로부터 추가된 로딩 상태
  const [showFeedbackModal, setShowFeedbackModal] = useState(true);
  const [showWithdrawalModal, setShowWithdrawalModal] = useState(false);
  const [showMyPageModal, setShowMyPageModal] = useState(true);
  const [showUserFeedbackModal, setShowUserFeedbackModal] = useState(true);
  const [showWarning, setShowWarning] = useState(false);
  const { startSSE } = useStore();

  const handleOpenModal = () => {
    setShowModal(true);
  };

  const handleConfirmModal = () => {
    console.log("확인 눌렸다!");
    setShowModal(false); // 모달 닫기
    console.log("닫았다!");
    //setShowCompare(true); // CaseComparison 보여주기
  };

  // 임시 - ModalThankLowGrant 무조건 실행되게 하기
  useEffect(() => {
    handleOpenModal();
  }, []);

  // 테스트용 질문 텍스트 (변경 시 여기만 수정)
  const testQuestion = '당근마켓에서 아이폰 12를 직거래로 25만원에 판매했어. 구매자가 직접 상태를 확인까지 하고, 문제 없다며 입금까지 마친 상황이었어. 그런데 며칠 뒤, 구매자가 "기기에 하자가 있다"며 환불을 요구하더니, 지속적으로 협박에 가까운 연락을 하고 있어. 실제로 판매 전 제품에는 하자가 없었고, 구매자도 직접 확인했는데 이런 식의 요구가 계속되고 있어. 이렇게 무리한 환불 요구는 협박죄에 해당할까? 혹시, 비슷한 사례중에 환불을 해준 사례가 있어?';

  // 테스트용 함수들
  const addStep = () => {
    startSSE(testQuestion, () => {
      console.log("Step completed");
    });
  };


  // const isOpen = true;
  // const userCreditList = dummyData; // 임시
  // return <PayList isOpen={isOpen} userCreditList={userCreditList} />;

  const inquiry = {
    key: "162",
    index: "36",
    courtName: "서울중앙지방법원",
    sentencingData: "2022.11.29",
    caseNumber: "2022나28842",
    caption:
      "부당이익금 부당이익금 부당이익금 부당이익금 부당이익금 부당이익금 부당이익금 부당이익금",
    relevance: 80,
    question:
      "운전하는 차가 앞차의 갑작스러운 멈춤으로 인해 충돌사고 시 누구의 과실로 판단되었는가?",
    detail:
      "1. 기초사실 【근거】 갑 제1 내지 7호증 보험관계 원고 차량 (차량번호 1 생략) 쏘렌토 승용차 피고 차량 (차량번호 2 생략) BMW 승용차 사고일시 및 장소 2021. 11. 20. 15:50경 성남시 분당구 D에 있는 E 주유소 맞은 편 도로 사고내용 피고 차량이 원고 차량을 뒤에서 추돌 피고의 과실비율 심의결정 청구 청구금액 : 1,236,960 F위원회의 과실비율 결정 결정일 : 2022. 1. 17.(이의마감일 : 2022. 2. 10.) 청구인 과실 : 피청구인 과실 = 70 : 30 심의결정금액 : 927,720원 심의결정금액 지급 및 소 제기 2022. 1. 28. 심의결정금액 지급 2022. 1. 28. 이 사건 소 제기 2. 쟁점 사고 발생의 원인(각 운전자의 과실비율) 3. 판단 모든 차의 운전자는 같은 방향으로 가고 있는 앞차의 뒤를 따르는 경우에는 앞차가 갑자기 정지하게 되는 경우 그 앞차와의 충돌을 피할 수 있는 필요한 거리를 확보하여야 하고(도로교통법 제19조 제1항), 위험방지를 위한 경우와 그 밖의 부득이한 경우가 아니면 운전하는 차를 갑자기 정지시키거나 속도를 줄이는 등의 급제동을 하여서는 아니 된다(도로교통법 제19조 제4항). 그런데 앞서 본 증거에 의하면, 원고보조참가인이 부득이한 사유 없이 갑자기 원고 차량을 정지한 사실과 피고 차량 운전자가 원고 차량과의 안전거리를 확보하지 아니한 채 뒤따라 피고 차량을 운전하다가 원고 차량을 추돌한 사실을 인정할 수 있다. 결국 이 사건 사고는 각 운전자의 과실이 경합하여 발생한 것이고(원고 주장대로 피고 차량 운전자가 갑자기 경적을 울리는 바람에 원고보조참가인이 주변을 확인하기 위하여 감속한 것이라고 주장하나, 설령 원고 주장 사실이 인정된다고 하더라도 도로 한가운데에서 원고 차량을 정차할 만한 정당한 사유라고 볼 수 없다),...",
    answer:
      "1. 원고의 항소를 기각한다. 2. 항소비용은 원고가 부담하고, 보조참가로 인한 부분은...",
    caseId: "1",
    isComparison: false,
    commonality:
      "운전하는 차가 앞차의 갑작스러운 멈춤으로 인해 충돌사고 시 누구의 과실로 판단되었는가?",
    difference:
      "운전하는 차가 앞차의 갑작스러운 멈춤으로 인해 충돌사고 시 누구의 과실로 판단되었는가?",
  };

  /* 테스트용 */
  const initialTextValue = "테스트";
  const onClose = () => {
    console.log("onClose 눌렸다");
  };

  const [windowDimensions, setWindowDimensions] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    function handleResize() {
      setWindowDimensions({
        width: window.innerWidth,
        height: window.innerHeight,
      });
      console.log(`Width: ${window.innerWidth}, Height: ${window.innerHeight}`);
    }

    window.addEventListener("resize", handleResize);

    // 초기 크기를 콘솔에 출력
    console.log(`Width: ${window.innerWidth}, Height: ${window.innerHeight}`);

    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    // <Loading />
    <>
      <ChatSearchHistory />
      <SSEProgressStack></SSEProgressStack>
      <TestButtonContainer>
        <TestButton onClick={addStep}>Step 추가</TestButton>
      </TestButtonContainer>
      <ModalUserWithdrawal 
        isOpen={showWithdrawalModal} 
        onClose={() => setShowWithdrawalModal(false)} 
      />
      <ModalMyPage
        isOpen={showMyPageModal}
        onClose={() => setShowMyPageModal(false)}
      />
      <SpinnerSSE />
      {/* <ModalSuccessLawCharge isOpen={showModal} onClose={handleConfirmModal} /> */}
      <div>
        <h1>Current window size</h1>
        <p>Width: {windowDimensions.width}</p>
        <p>Height: {windowDimensions.height}</p>
      </div>
      {/* <ModalAskError isOpen={showModal} onClose={handleConfirmModal} /> */}
      {/* <ModalIOSAddToHomeScreen
        isOpen={showModal}
        onClose={handleConfirmModal}
      /> */}
      {/* <ModalLawCharge
        isOpen={showModal}
        onClose={handleConfirmModal}></ModalLawCharge> */}
      {/* <ModalThankLowGrant isOpen={showModal} isConfirm={handleConfirmModal}  messageTitle="회원가입을 진심으로 축하드립니다!"
  messageSubtitle="축하 기념 15로우를 지급했습니다." /> */}
      <SituationBox
        title=""
        width={680}
        titleFontSize={16}
        intervalHeight={10}
        contents={3 > 0 ? "테스트" : ""}
        type="result"
      />
      <ReAskForm
        initialTextValue={initialTextValue}
        onClose={onClose}></ReAskForm>
      <IconContainer>
        <Button
          image_src={copy}
          alt_text="복사하기"
          imgWidth={32}
          imgHeight={32}
          // onClick={onCopy}
        ></Button>
        <Button
          image_src={search}
          alt_text="원문검색"
          imgWidth={32}
          imgHeight={32}
          // onClick={onSearch}
        ></Button>
      </IconContainer>
      {/* <AiHrStyles />
      <Overlay>
        <AiDiv>
          <img src={ai} width="21px" height="21px" />
          <AiText>내 상황과 비교하기</AiText>
          <img src={dots} width="13px" height="3px" />
        </AiDiv>
      </Overlay 13 3> */}
      {/* <Alert /> */}
      <ResultForm
        key={inquiry.index}
        index={inquiry.index}
        courtName={inquiry.courtName}
        sentencingData={inquiry.sentencingData}
        caseNumber={inquiry.caseNumber}
        caption={inquiry.caption}
        relevance={inquiry.relevance}
        question={inquiry.question}
        detail={inquiry.detail}
        answer={inquiry.answer}
        caseId={inquiry.id}
        isComparison={inquiry.isComparison}
        commonality={inquiry.commonality}
        difference={inquiry.difference}
      />
      <CaseFeedback />
      {/* {showFeedbackModal && (
        <ModalUserFeedback
          isOpen={true}
          onClose={() => setShowFeedbackModal(false)}
        />
      )} */}
      <WrapperMobile>
        <ResultFormMobile
          key={inquiry.index}
          index={inquiry.index}
          courtName={inquiry.courtName}
          sentencingData={inquiry.sentencingData}
          caseNumber={inquiry.caseNumber}
          caption={inquiry.caption}
          relevance={inquiry.relevance}
          question={inquiry.question}
          detail={inquiry.detail}
          answer={inquiry.answer}
          caseId={inquiry.id}
          isComparison={inquiry.isComparison}
          commonality={inquiry.commonality}
          difference={inquiry.difference}
        />
      </WrapperMobile>
      <CaseComparison
        caseId={inquiry.id}
        isComparison={inquiry.isComparison}
        commonality={inquiry.commonality}
        difference={inquiry.difference}
        // setLoading={setIsLoading} // 로딩 상태 전달
      />
      {/* <RelevanceChart /> */}
      <img src={dots_gif} width="20px" height="20px" alt="Dots Gif" />
      <img src={dots_png} width="20px" height="20px" alt="Dots Png" />
      <TooltipComponent />
      <button onClick={() => setShowUserFeedbackModal(true)}>
        유저 피드백 모달 테스트
      </button>
      <div style={{ position: "relative", display: "inline-block" }}>
        <ModalUserFeedback
          isOpen={showUserFeedbackModal}
          onClose={() => setShowUserFeedbackModal(false)}
          onSubmit={() => setShowUserFeedbackModal(false)}
          onShowWarning={() => {
            setShowWarning(true);
            setTimeout(() => setShowWarning(false), 2000);
          }}
        />
        <WarningBox show={showWarning}>
          <ContentWrapper>
            <StyledWarningIcon src={warning} alt="경고" />
            <StyledWarningText>
              만족도 옵션 중 하나를 선택해야 제출할 수 있습니다.
            </StyledWarningText>
          </ContentWrapper>
        </WarningBox>
      </div>
    </>
  );
};

const WrapperMobile = styled.div`
  width: auto;
  margin: 0px 24px; /* 좌우 margin 24px */
`;

const IconContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  left: 24px;
  bottom: 32px;
  z-index: 10; // Wrapper와 다른 내용물 위에 올라오도록 z-index 설정
  height: 80px;

  img {
    width: 20px;
    height: 20px;
    margin-bottom: 8px;
    filter: black;
  }

  /* 모바일 환경 */
  @media (max-width: 1439px) {
    height: auto;
    bottom: 54px;
    // margin-left: 18px;
  }
`;

const WarningBox = styled.div`
  position: fixed;
  left: 50%;
  top: calc(50% + 255px); // 모달 중앙 아래로 240px(모달 높이/2 + 12px 등) 조정
  transform: translateX(-50%) translateY(${props => props.show ? '0' : '10px'});
  width: 400px;
  height: 44px;
  border-radius: 16px;
  background: #FFF;
  display: flex;
  align-items: center;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
  border: 1px solid transparent;
  gap: 0;
  opacity: ${props => props.show ? 1 : 0};
  transition: opacity 300ms ease-out, transform 300ms ease-out;
  z-index: 1000;

  @media (max-width: 430px) {
    width: 312px;
    top: calc(50% + 225px); // 모바일 모달 하단 + 12px (모달 높이에 맞게 조정)
  }
`;

const ContentWrapper = styled.div`
  display: flex;
  align-items: center;
  padding-left: 16px;
  width: 100%;
  height: 100%;
`;

const StyledWarningIcon = styled.img`
  width: 20px;
  height: 20px;
  margin-right: 8px;
`;

const StyledWarningText = styled.span`
  color: rgba(0, 0, 0, 0.60);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px; 
  letter-spacing: -0.28px;

  @media (max-width: 430px) {
    font-size: 12px;
    letter-spacing: -0.24px;
  }
`;

const TestButtonContainer = styled.div`
  display: flex;
  gap: 12px;
  margin: 20px;
  justify-content: center;
`;

const TestButton = styled.button`
  padding: 8px 16px;
  background-color: #007AFF;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;

  &:hover {
    background-color: #0056b3;
  }
`;

export default Test;
